module.exports = ".sebm-google-map-container {\n   height: 800px;\n }"


//////////////////
// WEBPACK FOOTER
// ./src/app/mapstest/mapstest.component.css
// module id = ./src/app/mapstest/mapstest.component.css
// module chunks = main